import React, { useEffect } from 'react';
import useTranslation from '../hooks/useTranslation';
import { useOperationTime } from '../hooks/useOperationTime';

interface ServiceClosedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ServiceClosedModal: React.FC<ServiceClosedModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { operationStatus } = useOperationTime();

  // 모달이 열릴 때 3초 후 자동으로 닫기
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);

  // ESC 키로 모달 닫기
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-sm mx-4 text-center">
        {/* 아이콘 */}
        <div className="mb-4">
          <svg 
            className="w-16 h-16 mx-auto text-red-500" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
            />
          </svg>
        </div>

        {/* 제목 */}
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          {t('service.closed.title')}
        </h2>

        {/* 서버에서 가져온 운영시간 메시지 */}
        <p className="text-gray-600 text-sm">
          {operationStatus.operationHours || t('service.closed.message')}
        </p>

        {/* 자동 닫힘 안내 */}
        <p className="text-xs text-gray-400 mt-4">
          {t('service.closed.autoClose')}
        </p>
      </div>
    </div>
  );
};

export default ServiceClosedModal; 